import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsHide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsHide"><Path d="M15.707 16.293L14.293 17.707L13 16.4141V21H11V16.4141L9.70703 17.707L8.29297 16.293L12 12.5859L15.707 16.293Z" fill="currentColor"/><Path d="M8 6H4V18H8V20H2V4H8V6Z" fill="currentColor"/><Path d="M22 20H16V18H20V6H16V4H22V20Z" fill="currentColor"/><Path d="M13 7.58594L14.293 6.29297L15.707 7.70703L12 11.4141L8.29297 7.70703L9.70703 6.29297L11 7.58594V3H13V7.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsHide;
